export const defaultContractLengths = [1,3,6,9,12,15,18,21,24,27,30,33,36,48,60]
